<script>
  import { createEventDispatcher } from "svelte";
  import SideKPI from "../../../../lib/components/sideKPI.svelte";
  import { Pagination } from "paxray-components-svelte";

  export let caseids = [];
  export let manualDrawings = [];
  export let selectedCaseids = [];
  export let selectedStartnodes = [];
  export let selectedManualDrawingId = "";
  export let selectedManualStartnode = "";
  const dispatch = createEventDispatcher();
  let searchTerm = "";
  let sortBy = "name";
  let sortDirection = 1;
  let currentPage = 1;
  let editingManualDrawingId = "";
  let editingManualDrawingName = "";
  const itemsPerPage = 5;

  $: selectionItems = [
    ...caseids.map((item) => ({
      ...item,
      kind: "observed",
      name: item.record_type,
      count: Number(item.case_count || 0),
    })),
    ...manualDrawings.map((item) => ({
      ...item,
      kind: "manual",
      count: -1,
    })),
  ];
  $: filteredCaseids = selectionItems.filter((item) =>
    `${item.name} ${(item.startnodes || []).join(" ")} ${item.kind}`.toLowerCase().includes(searchTerm.trim().toLowerCase()),
  );
  $: sortedCaseids = [...filteredCaseids].sort((a, b) => {
    const comparison = sortBy === "count"
      ? Number(a.count || 0) - Number(b.count || 0)
      : String(a.name || "").localeCompare(String(b.name || ""));
    return comparison * sortDirection;
  });
  $: pageCount = Math.max(1, Math.ceil(sortedCaseids.length / itemsPerPage));
  $: if (currentPage > pageCount) currentPage = pageCount;
  $: displayedCaseids = sortedCaseids.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  function toggleSelection(id) {
    if (selectedCaseids.includes(id)) {
      selectedCaseids = selectedCaseids.filter((selectedId) => selectedId !== id);
      return;
    }
    selectedCaseids = [...selectedCaseids, id];
  }

  function toggleStartnode(node) {
    if (selectedStartnodes.includes(node)) {
      selectedStartnodes = selectedStartnodes.filter((selected) => selected !== node);
      return;
    }
    selectedStartnodes = [...selectedStartnodes, node];
  }

  function selectManualDrawing(item, startnode = "") {
    dispatch("selectManual", { id: item.id, startnode });
  }

  function deleteManualDrawing(event, item) {
    event.stopPropagation();
    dispatch("deleteManual", { id: item.id });
  }

  function startRenameManualDrawing(event, item) {
    event.stopPropagation();
    editingManualDrawingId = item.id;
    editingManualDrawingName = item.name;
  }

  function saveManualDrawingName(event, item) {
    event.stopPropagation();
    const name = editingManualDrawingName.trim();
    if (name) dispatch("renameManual", { id: item.id, name });
    editingManualDrawingId = "";
    editingManualDrawingName = "";
  }

  function sortCaseids(field) {
    sortDirection = sortBy === field ? sortDirection * -1 : 1;
    sortBy = field;
    currentPage = 1;
  }
</script>

<div class="app_selection_wrapper">
  <div class="search">
    <img src="/img/ui_icons/search.svg" alt="" />
    <input type="text" bind:value={searchTerm} on:input={() => currentPage = 1} placeholder="Search for object" />
  </div>
  <div class="sorters">
    <button type="button" class="sort-button" on:click={() => sortCaseids("name")}>
      <span>Sort by name</span>
      <img class:descending={sortBy === "name" && sortDirection < 0} src={`/img/assistant/icons/${sortBy === "name" ? "sorted-arrow2" : "sort-arrow"}.svg`} alt="" />
    </button>
    <button type="button" class="sort-button" on:click={() => sortCaseids("count")}>
      <span>Sort by number</span>
      <img class:descending={sortBy === "count" && sortDirection < 0} src={`/img/assistant/icons/${sortBy === "count" ? "sorted-arrow2" : "sort-arrow"}.svg`} alt="" />
    </button>
  </div>
  <div class="bar_wrapper">
    {#each displayedCaseids as item}
      {#if item.kind === "manual"}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          class="kpi_wrapper appinfo_wrapper manual-item"
          class:selected-task={selectedManualDrawingId === item.id && !selectedManualStartnode}
          on:click={() => selectManualDrawing(item)}
        >
          {#if editingManualDrawingId === item.id}
            <input
              class="manual-name-input"
              bind:value={editingManualDrawingName}
              on:click|stopPropagation
              on:keydown={(event) => {
                if (event.key === "Enter") saveManualDrawingName(event, item);
                if (event.key === "Escape") editingManualDrawingId = "";
              }}
            />
          {:else}
            <span class="manual-name" title={item.name}>{item.name}</span>
          {/if}
          <span class="manual-badge">Manual</span>
          <button
            type="button"
            class="manual-action"
            title={editingManualDrawingId === item.id ? "Save name" : "Rename drawing"}
            aria-label={editingManualDrawingId === item.id ? `Save ${item.name}` : `Rename ${item.name}`}
            on:click={(event) => editingManualDrawingId === item.id
              ? saveManualDrawingName(event, item)
              : startRenameManualDrawing(event, item)}
          >
            <img src={`/img/assistant/icons/${editingManualDrawingId === item.id ? "save" : "edit"}.svg`} alt="" />
          </button>
          <button type="button" class="manual-delete" title="Delete drawing" aria-label={`Delete ${item.name}`} on:click={(event) => deleteManualDrawing(event, item)}>
            <img src="/img/assistant/icons/trash.svg" alt="" />
          </button>
        </div>
      {:else}
        <!-- svelte-ignore missing-declaration -->
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
          class="kpi_wrapper appinfo_wrapper"
          class:selected-task={!selectedManualDrawingId && selectedCaseids.includes(item.id)}
          on:click={() => toggleSelection(item.id)}
        >
          <SideKPI name={item.name} value={`${item.case_count || 0} Cases`}></SideKPI>
        </div>
      {/if}
      {#if item.startnodes?.length}
        <div class="startnode_wrapper">
          {#each item.startnodes as startnode}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <div
              class="startnode_item"
              class:selected-task={item.kind === "manual"
                ? selectedManualDrawingId === item.id && selectedManualStartnode === startnode
                : !selectedManualDrawingId && selectedStartnodes.includes(startnode)}
              on:click={() => item.kind === "manual"
                ? selectManualDrawing(item, startnode)
                : toggleStartnode(startnode)}
            >
              <span class="start-badge">Start</span>
              <span class="start-label">{startnode}</span>
            </div>
          {/each}
        </div>
      {/if}
    {/each}
  </div>
  {#if filteredCaseids.length}
    <Pagination
      basic
      totalItems={filteredCaseids.length}
      bind:page={currentPage}
      pageSize={itemsPerPage}
    />
  {/if}
</div>

<style>
  .appinfo_wrapper {
    cursor: pointer;
    align-items: center;
    height: 2.125rem;
    border-radius: 0.5rem;
    border: 1px solid var(--pax-smoke);
  }

  :global(.appinfo_wrapper > .kpi_wrapper) {
    height: 100%;
    padding: 0 1rem;
  }

  .bar_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-bottom: 1rem;
  }

  .app_selection_wrapper {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .selected-task {
    border: 1px solid var(--pax-black) !important;
    border-radius: 0.5rem;
  }

  .startnode_wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-left: 1.35rem;
    padding-left: 0.8rem;
    border-left: 1px dotted #c7ccd2;
  }

  .startnode_item {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    height: 2.125rem;
    padding: 0 0.5rem;
    border: 1px solid transparent;
    border-radius: 0.5rem;
    background: #f4f4f4;
    font-size: 0.875rem;
  }

  .search {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    height: 3rem;
    display: flex;
    align-items: center;
    padding: 0 1rem;
    border: 1px solid var(--pax-black);
    border-radius: 0.5rem;
  }

  .search img {
    width: 1.5rem;
    height: 1.5rem;
  }

  .search input {
    box-sizing: border-box;
    flex: 1 1 auto;
    min-width: 0;
    width: auto;
    padding-left: 1rem;
    border: 0;
    outline: 0;
  }

  .sorters {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.5rem;
  }

  .sort-button {
    min-width: 0;
    width: 100%;
    height: 1.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.65rem;
    padding: 0 0.65rem;
    border: 0;
    border-radius: 0.5rem;
    background: var(--pax-black);
    color: #fff;
    cursor: pointer;
    font-size: 0.75rem;
  }

  .sort-button img {
    width: 0.75rem;
    height: 0.75rem;
  }

  .sort-button img.descending {
    transform: rotate(180deg);
  }

  .start-badge {
    flex: 0 0 auto;
    padding: 0.12rem 0.35rem;
    border-radius: 999px;
    background: var(--pax-black);
    color: #fff;
    font-size: 0.58rem;
    font-weight: 700;
  }

  .start-label {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .manual-item {
    display: flex;
    padding: 0 0.5rem 0 1rem;
    gap: 0.5rem;
    background: #f4f4f4;
  }

  .manual-name,
  .manual-name-input {
    min-width: 0;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 0.875rem;
  }

  .manual-name-input {
    height: 1.5rem;
    padding: 0 0.35rem;
    border: 1px solid #8d8d8d;
    border-radius: 0.25rem;
    background: #fff;
    outline: 0;
  }

  .manual-badge {
    flex: 0 0 auto;
    padding: 0.12rem 0.45rem;
    border-radius: 999px;
    background: #e8e8e8;
    color: #525252;
    font-size: 0.65rem;
    font-weight: 600;
  }

  .manual-action,
  .manual-delete {
    flex: 0 0 auto;
    width: 1.6rem;
    height: 1.6rem;
    display: grid;
    place-items: center;
    padding: 0;
    border: 0;
    border-radius: 0.3rem;
    background: var(--pax-black);
    cursor: pointer;
  }

  .manual-action img,
  .manual-delete img {
    width: 0.85rem;
    height: 0.85rem;
    filter: brightness(0) invert(1);
  }
</style>
